// PUIU MAMEI — Main JS

document.addEventListener('DOMContentLoaded', function () {

  // ---- Mobile menu ----
  const hamburger = document.querySelector('.nav-hamburger');
  const drawer = document.querySelector('.mobile-nav-drawer');
  const overlay = document.querySelector('.mobile-nav-overlay');
  const closeBtn = document.querySelector('.mobile-nav-close');

  function openMenu() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-active');
    document.body.classList.add('nav-open');
    hamburger.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-active');
    document.body.classList.remove('nav-open');
    hamburger.setAttribute('aria-expanded', 'false');
  }

  if (hamburger) {
    hamburger.addEventListener('click', openMenu);
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', closeMenu);
  }
  if (overlay) {
    overlay.addEventListener('click', closeMenu);
  }

  // Close on ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeMenu();
    }
  });

  // ---- Newsletter form ----
  const newsletterInput = document.querySelector('.newsletter-input');
  const newsletterBtn = document.querySelector('.newsletter-btn');

  if (newsletterBtn) {
    newsletterBtn.addEventListener('click', function () {
      var email = newsletterInput.value.trim();
      if (email && email.includes('@')) {
        newsletterBtn.textContent = 'JOINED!';
        newsletterBtn.style.background = '#4caf50';
        newsletterBtn.style.color = '#fff';
        newsletterInput.value = '';
        setTimeout(function () {
          newsletterBtn.textContent = 'JOIN';
          newsletterBtn.style.background = '#fff';
          newsletterBtn.style.color = '#000';
        }, 3000);
      } else {
        newsletterInput.style.borderBottom = '2px solid red';
        setTimeout(function () {
          newsletterInput.style.borderBottom = '';
        }, 2000);
      }
    });
  }

  // ---- Smooth header shadow on scroll ----
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)';
      } else {
        header.style.boxShadow = 'none';
      }
    });
  }

});

// ---- How to Use: tap anywhere on a pouch card or a Side photo to see it larger ----
document.addEventListener('DOMContentLoaded', function () {

  // Pouch cards: the name, line and size open the same larger view as the photo.
  document.querySelectorAll('.pm-inside__item').forEach(function (item) {
    var trigger = item.querySelector('[data-pm-zoom]');
    var copy = item.querySelector('.pm-inside__copy');
    if (!trigger || !copy) return;
    copy.style.cursor = 'zoom-in';
    copy.addEventListener('click', function () { trigger.click(); });
  });

  // Side A / B / C photos: open larger instead of leaving the page.
  var cards = Array.prototype.slice.call(document.querySelectorAll('.pm-photos__item')).filter(function (c) { return c.querySelector('img'); });
  if (!cards.length) return;

  var css = document.createElement('style');
  css.textContent =
    '.pm-plb{position:fixed;inset:0;z-index:10000;background:#fff;display:none;opacity:0;transition:opacity .25s ease}' +
    '.pm-plb.is-open{display:flex}.pm-plb.is-visible{opacity:1}' +
    '.pm-plb__stage{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:72px 96px 40px;min-width:0}' +
    '.pm-plb__frame{flex:1;min-height:0;width:100%;display:flex;align-items:center;justify-content:center}' +
    '.pm-plb__frame img{display:block;max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain}' +
    '.pm-plb__caption{text-align:center;max-width:520px;margin:28px auto 0}' +
    '.pm-plb__name{font-family:var(--font-heading);font-size:18px;letter-spacing:.08em;text-transform:uppercase;margin:0;color:#000}' +
    '.pm-plb__text{margin:10px 0 0;font-size:14px;line-height:1.6;color:#444}.pm-plb__text p{margin:0 0 6px}' +
    '.pm-plb__btn{position:absolute;background:none;border:0;padding:14px;cursor:pointer;color:#000;line-height:0}' +
    '.pm-plb__btn:hover{opacity:.55}.pm-plb__close{top:18px;right:18px}' +
    '.pm-plb__prev{left:20px;top:50%;transform:translateY(-50%)}.pm-plb__next{right:20px;top:50%;transform:translateY(-50%)}' +
    '.pm-photos__img,.pm-photos__item .pm-inside__name,.pm-photos__item .pm-photos__text{cursor:zoom-in}' +
    'body.pm-plb-lock{overflow:hidden}' +
    '@media (max-width:768px){.pm-plb__stage{padding:64px 20px 32px}.pm-plb__prev,.pm-plb__next{top:auto;bottom:18px;transform:none}.pm-plb__prev{left:8px}.pm-plb__next{right:8px}.pm-plb__caption{margin-top:20px;padding:0 44px}.pm-plb__name{font-size:16px}.pm-plb__text{font-size:13px}}';
  document.head.appendChild(css);

  var lb = document.createElement('div');
  lb.className = 'pm-plb';
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-modal', 'true');
  lb.setAttribute('aria-hidden', 'true');
  lb.innerHTML =
    '<button type="button" class="pm-plb__btn pm-plb__close" aria-label="Close"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M2 2l18 18M20 2L2 20"/></svg></button>' +
    '<button type="button" class="pm-plb__btn pm-plb__prev" aria-label="Previous photo"><svg width="14" height="26" viewBox="0 0 14 26" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M13 1L1 13l12 12"/></svg></button>' +
    '<button type="button" class="pm-plb__btn pm-plb__next" aria-label="Next photo"><svg width="14" height="26" viewBox="0 0 14 26" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M1 1l12 12L1 25"/></svg></button>' +
    '<div class="pm-plb__stage"><div class="pm-plb__frame"></div><div class="pm-plb__caption"><p class="pm-plb__name"></p><div class="pm-plb__text"></div></div></div>';
  document.body.appendChild(lb);

  var frame = lb.querySelector('.pm-plb__frame');
  var nameEl = lb.querySelector('.pm-plb__name');
  var textEl = lb.querySelector('.pm-plb__text');
  var stage = lb.querySelector('.pm-plb__stage');
  var current = 0;

  function bigSrc(img) {
    var src = img.currentSrc || img.src;
    return src.replace(/([?&])width=\d+/, '$1width=2000');
  }
  function render(i) {
    current = i;
    var card = cards[i];
    var img = card.querySelector('img');
    var title = card.querySelector('.pm-inside__name');
    var text = card.querySelector('.pm-photos__text');
    frame.innerHTML = '';
    var big = new Image();
    big.alt = img.alt || '';
    big.src = bigSrc(img);
    frame.appendChild(big);
    nameEl.textContent = title ? title.textContent : '';
    textEl.innerHTML = text ? text.innerHTML : '';
  }
  function open(i) {
    lb.classList.add('is-open');
    lb.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pm-plb-lock');
    render(i);
    requestAnimationFrame(function () { lb.classList.add('is-visible'); });
  }
  function close() {
    lb.classList.remove('is-visible');
    lb.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pm-plb-lock');
    setTimeout(function () { lb.classList.remove('is-open'); }, 250);
  }
  function step(n) { render((current + n + cards.length) % cards.length); }

  cards.forEach(function (card, i) {
    card.addEventListener('click', function (e) {
      if (e.target.closest('.pm-photos__img, .pm-inside__name, .pm-photos__text')) {
        e.preventDefault();
        open(i);
      }
    });
  });
  lb.querySelector('.pm-plb__close').addEventListener('click', close);
  lb.querySelector('.pm-plb__prev').addEventListener('click', function () { step(-1); });
  lb.querySelector('.pm-plb__next').addEventListener('click', function () { step(1); });
  stage.addEventListener('click', function (e) { if (e.target === stage || e.target === frame) close(); });
  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') step(1);
    else if (e.key === 'ArrowLeft') step(-1);
  });
  var sx = null, sy = null;
  lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
  lb.addEventListener('touchend', function (e) {
    if (sx === null) return;
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
    sx = sy = null;
  });
});
